const mikeConfigs = {
  width: 225,
  height: 224,
  moveLeftStart: 900,
  moveLeftEnd: 1575,
  moveRightStart: 0,
  moveRightEnd: 675,
  interval: 100,
};

export const hunterConfigs = {
  width: 240,
  height: 221,
  moveLeftStart: 720,
  moveLeftEnd: 1440,
  moveRightStart: 0,
  moveRightEnd: 720,
  interval: 100,
  endAttackPos: 1920,
};

export const mageConfigs = {
  width: 240,
  height: 215,
  moveLeftStart: 720,
  moveLeftEnd: 1440,
  moveRightStart: 0,
  moveRightEnd: 720,
  interval: 100,
  endAttackPos: 1920,
};

export const warriorConfigs = {
  width: 240,
  height: 221,
  moveLeftStart: 720,
  moveLeftEnd: 1440,
  moveRightStart: 0,
  moveRightEnd: 720,
  interval: 100,
  endAttackPos: 1920,
};

export const charChangeConfigs = {
  width: 225,
  height: 224,
  moveLeftStart: 0,
  moveLeftEnd: 1800,
  moveRightStart: 0,
  moveRightEnd: 1800,
  interval: 140,
};

export const spiderConfigs = {
  width: 150,
  height: 305,
  interval: 150,
  start: 0,
  end: 1500,
};

export const batsConfigs = {
  width: 150,
  height: 206,
  interval: 70,
  start: 0,
  end: 1200,
};

export const wolfConfigs = {
  width: 400,
  height: 201,
  interval: 80,
  start: 0,
  end: 4000,
};

export const surferConfigs = {
  width: 400,
  height: 303,
  interval: 80,
  moveLeftStart: 1600,
  moveLeftEnd: 3200,
  moveRightStart: 0,
  moveRightEnd: 1600,
};

export const guitarPlayerConfigs = {
  width: 308,
  height: 198,
  interval: 70,
  start: 0,
  end: 3080,
};

export const magicBookConfigs = {
  width: 154,
  height: 149,
  interval: 100,
  start: 0,
  end: 2002,
};

export const chestConfigs = {
  width: 400,
  height: 204,
  interval: 100,
  start: 0,
  end: 3600,
};

export default mikeConfigs;
